import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { ModalService } from '../../../core/services/modal.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';
import { Item } from '../../../core/components/listbox/listbox.component';

@Component({
  selector: 'tt-operation-factory',
  templateUrl: './operation-factory.component.html',
  styleUrls: ['./operation-factory.component.css']
})
export class OperationFactoryComponent implements OnInit {
    operationFactoryKeyno;

    public edit?: Edit;

    public selectListEquipments: Item[] = [];

    public factoryNameButtons: FormButton[] = [
        { id: 'goto', type: 'primary', icon: 'fas fa-chevron-right', goto: 'factorymenu', gotoParms: () => this.edit!.factory_id ?? '' }
    ];

    public saving = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.operationFactoryKeyno = this.stateService.getStateParams()['operationfactory_keyno'];
    }

    private async loadEdit() {
        if (!!this.operationFactoryKeyno) {
            this.edit = (await this.datatask.Post(2038, { operationfactory_keyno: this.operationFactoryKeyno }))[0];
        }
    }

    private async loadEquipents(): Promise<void> {
        if (!!this.edit) {
            return this.selectListEquipments = await this.datatask.Post(2039, {
                factory_id: this.edit?.factory_id,
                operation_id: this.edit?.operation_id
            });
        }
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(2044, this.edit))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        await this.loadEdit();
        this.loadEquipents();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    operationfactory_keyno: number;
    factory_id: string;
    factory_name: string;
    operation_id: string;
    operation_name: string;
    equipment_id: string;
    businessco_companyname: string;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('operationFactory', {
//        templateUrl: 'views/components/views/operationFactory/operationFactory.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'utilityService', 'modalService', 'translateService', 'operationFactoryService', function ($stateParams, stateService, utilityService, modalService, translateService, operationFactoryService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let operationFactoryKeyno = $stateParams.operationfactory_keyno;

//            let translations = {
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                factoryNameButtons: [
//                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('factorymenu', { factory_id: vm.model.edit.factory_id }) }
//                ],
//                edit: {},
//                selectListEquipments: [],
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATION FUNCTION

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATION FUNCTION

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadEdit() {
//                vm.model.edit = (await operationFactoryService.getOperationFactory({ operationfactory_keyno: operationFactoryKeyno }))[0];

//                return loadSelectEquipents();
//            }

//            async function loadSelectEquipents() {
//                if (utilityService.validateParmsValue(vm.model.edit.factory_id) !== true) return;
//                if (utilityService.validateParmsValue(vm.model.edit.operation_id) !== true) return;

//                return vm.model.selectListEquipments = await operationFactoryService.listSelectEquipments({
//                    factory_id: vm.model.edit.factory_id,
//                    operation_id: vm.model.edit.operation_id
//                });
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                operationFactoryService.saveObj(vm.model.edit).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                        modalService.show({
//                            type: 'warning',
//                            title: translations.error,
//                            message: response[0].errormessage,
//                            buttons: [{
//                                label: translations.ok,
//                                cssClass: 'btn-warning',
//                                action: function (dialogItself) {
//                                    dialogItself.close();
//                                    vm.model.lockedSave = false;
//                                }
//                            }]
//                        });
//                    } else {
//                        vm.model.lockedSave = false;
//                        stateService.back();
//                    }
//                });
//            };

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                translate();
//                loadEdit();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
